import React from 'react';
import SectionIcon from './SectionIcon';
import ExportCheckbox from './ExportCheckbox';
import ExpandCollapseButton from './ExpandCollapseButton';

const SectionHeader = ({
  sectionType,
  itemKey,
  zones,
  doc2Visibility,
  toggleDoc2Visibility,
  handleSectionExport,
  markAllCheckboxes,
  icon,
  sectionId
}) => {
  // Different positioning based on section type
  const positioningStyles = {
    yellow: {
      container: {
        marginTop: '10px',
      },
      label: {
        bottom: '40px',
      },
      section: {
        bottom: '44px',
      }
    },
    green: {
      container: {
        marginTop: '-20px',
      },
      label: {
        bottom: '40px',
      },
      section: {
        bottom: '40px',
      }
    },
    zero: {
      container: {
        marginTop: '-20px',
      },
      label: {
        bottom: '40px',
      },
      section: {
        bottom: '40px',
      }
    }
  };

  const styles = positioningStyles[sectionType];

  return (
    <div
      style={{
        display: 'flex',
        position: 'absolute',
        marginTop: styles.container.marginTop,
        marginLeft: '46%',
        boxSizing: 'border-box',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        zIndex: '900',
        width: '54%',
        float: 'right',
      }}
    >
      <SectionIcon icon={icon} sectionType={sectionType} />
      
      <ExportCheckbox 
        sectionId={sectionId}
        handleSectionExport={handleSectionExport}
        markAllCheckboxes={markAllCheckboxes}
        style={{
          marginLeft: '25%', 
          bottom: styles.label.bottom, 
          right: '24px'
        }}
      />
      
      <ExpandCollapseButton 
        itemKey={itemKey}
        sectionType={sectionType}
        doc2Visibility={doc2Visibility}
        toggleDoc2Visibility={toggleDoc2Visibility}
        style={{
          bottom: styles.section.bottom
        }}
      />
    </div>
  );
};

export default SectionHeader;
